export enum ShowingActionIntent {
  RESCHEDULE = 'Reschedule',
  STOP = 'Stop',
}
